import { BasePageQueryParams } from 'src/components/general/table-helpers';
import { TasksFiltersFormValues } from 'src/components/pages/tasks/components/tasks-filters';

export type TasksPageAdvancedQueryParams = Omit<
  TasksFiltersFormValues,
  'agent' | 'group'
> & {
  agent?: string;
  group?: string;
  created_by?: string;
};

export type TasksPageQueryParams = BasePageQueryParams<
  'today' | 'upcoming' | 'completed' | 'overdue',
  TasksPageAdvancedQueryParams
>;

export enum TaskStatusResolver {
  'YET-TO-START' = 'YET_TO_START',
  COMPLETED = 'COMPLETED',
  'IN-PROGRESS' = 'IN_PROGRESS',
}
